import React from "react";
import { Box, Card, Typography ,CardContent,Avatar,Divider} from "@mui/material";
import CouponSection from "../CouponAvalibleSection/component";
import CouponRewardCard from "../CouponReward/component";
import { useNavigate } from "react-router-dom";
import MoreCardsSection from "../DigittalProductSuggestion/DigittalProductSuggestion";
import AmazonLogo from "../../../assets/amazon.png";
import QuickPurchaseCards from "../DigittalProductSuggestion/DigittalProductSuggestion";
const CartList = ({ RemoveCoupon,cartList, increaseQuantity, decreaseQuantity,
  fetchCouponsList ,setShowCoupoListFlag,fullObjectRewardCart,removebtnflag ,ConformRemoveCoupon,digitalSuggestionItems}) => {
    //logger.log("fullObjectRewardCart",fullObjectRewardCart)
    const navigate=useNavigate();
  const TruncatedVmname = ({ text = "", limit = 25 }) => (
    <span style={{ fontSize: "14px", color: "#384F6F" }}>
      {text.length <= limit ? text : `${text.substring(0, limit)}...`}
    </span>
  );

   const TruncatedDescribation = ({ text = "", limit = 25 }) => (
    <span style={{ fontSize: "14px", color: "#94A3B8" }}>
      {text.length <= limit ? text : `${text.substring(0, limit)}...`}
    </span>
  );

  const handleItems=()=>{
    navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`)
  }
  const totalItemCount = cartList.reduce((total, item) => total + item.count, 0);
  return (
    <>

    <div style={{padding:"15px",paddingTop:"80px",    paddingBottom: "170px"}}>
          <Box display={"flex"} justifyContent={"space-between"}>
   <Typography
  style={{
    color: "rgba(113, 129, 152, 1)",
    fontSize: "17px",
    fontWeight: "500",
    padding: "10px",
  }}
>
 
 {totalItemCount} Item{totalItemCount > 1 ? "s" : ""} In Your Cart
</Typography>

           <Typography
        style={{
          color: "rgb(0,177,119)",
          fontSize: "17px",
          fontWeight: "500",
        padding:"10px"
        }}
          onClick={(e)=>{handleItems(e)}}
      >
+ add item
      </Typography>
</Box>
      {[
        ...cartList.filter((el) => !el.isDigital).slice().reverse(),
        ...cartList.filter((el) => el.isDigital).slice().reverse(),
      ].map((el, index) => (
        <React.Fragment key={`${el.slotId ?? el.slot_id ?? "item"}-${index}`}>
        {el.isDigital==true?<>   
        {
          !(el.isFree==false)? 
         <Card
          sx={{
             mb: 3,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 4px 10px rgba(56, 79, 111, 0.12)",
          }}
        >
          <CardContent>
            <Box display="flex" justifyContent="space-between"     alignItems= "center">
              <Box display="flex" gap={2}>
          <img src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.variantImages[0]}`} alt="Amazon Logo" style={{ width: "70px", height: "50px" }} />

                <Box>
                  <Typography fontWeight={600}>
                   {el?.mvName}
                  </Typography>

                  <Typography color="text.secondary">
                  
                  {el?.fulfilmentType}
                  </Typography>

                  <Typography
                    fontWeight={700}
                    color="#00B67A"
                  >
                    {el?.amount==0.0?"Free":"₹ " + el.amount.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </CardContent>

          <Divider sx={{ borderColor: "#00000033" }} />

          <Typography
            textAlign="center"
            py={1}
            fontStyle="italic"
            fontWeight={600}
            fontSize={13}
            color="#4c5c78"
          >
            Digital Item Unlocks After Physical Pickup
          </Typography>
        </Card>
        :  
        <Card
          sx={{
             mb: 3,
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0px 4px 10px rgba(56, 79, 111, 0.12)",
          }}
        >
          <CardContent>
            <Box display="flex" justifyContent="space-between"     alignItems= "center">
              <Box display="flex" gap={2}>
          <img src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.variantImages[0]}`} alt="Amazon Logo" style={{ width: "70px", height: "50px" }} />

                <Box>
                  <Typography fontWeight={600} style={{color:"#384F6F"}}>
                 <TruncatedVmname text={el.mvName} limit={25} />  
                  </Typography>

                  <Typography style={{color:"#94A3B8",fontSize:"12px"}}>
                  
                  {el?.fulfilmentType}
                  </Typography>
     <Typography style={{color:"#94A3B8",fontSize:"12px"}}>
                 
                  Item Left.{el?.availableCount}
                  </Typography>
                  <Typography
                    fontWeight={700}
                    color="#00B67A"
                  >
                    {el?.amount==0.0?"Free":"₹ " + el.amount.toFixed(2)}
                  </Typography>
                </Box>
                
              </Box>
              
              {/* Quantity Controls */}
              {el.count > 0 ? (
                <Box
                style={{backgroundColor:"#00B177"}}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width={100}
                  px={1}
                  py={0.5}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  bgcolor="rgba(0, 177, 119, 0.04)"
                 
                >
                  <Typography
                    onClick={(e) => decreaseQuantity(e, index, el.slotId, el.count)}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    -
                  </Typography>
                  <Typography fontSize="14px" fontWeight={500} color={"white"}>
                    {el.count}
                  </Typography>
                  <Typography
                    onClick={(e) => increaseQuantity(e, index, el.slotId, el.count,"add")}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    +
                  </Typography>
                </Box>
              ) : (
                <Box
                  onClick={(e) => increaseQuantity(e, index, el.slot_id, el.count,"add")}
                  width={100}
                  textAlign="center"
                  py={0.7}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  color="#00B177"
                  fontWeight={600}
                  sx={{
                    cursor: "pointer",
                    bgcolor: "rgba(0, 177, 119, 0.04)",
                    userSelect: "none",
                  }}
                >
                  ADD
                </Box>
              )}
            </Box>
          </CardContent>


        
        </Card>}
        </>
:      
  <Box
          key={index}
          mb={3}
          p={2}
          display="flex"
          alignItems="center"
          borderRadius="16px"
          boxShadow="0px 4px 10px rgba(56, 79, 111, 0.12)"
          sx={{ backgroundColor: "white" }}
        >
          {/* Product Image */}
          <Box
            sx={{
              height: 78,
              width: 77,
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              backgroundColor: "#f5f5f5",
            }}
          >
            {el.variantImages?.[0] ? (
              <img
                src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.variantImages[0]}`}
                alt={el.mvName}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                loading="lazy"
              />
            ) : (
              <Typography variant="caption" color="text.secondary">
                No Image
              </Typography>
            )}
          </Box>

          {/* Product Details */}
          <Box flex={1}>
            <Box display={"flex"} justifyContent={"space-between"} alignContent={"center"}>
            <Typography variant="body2" >
              <TruncatedVmname text={el.mvName} limit={25} />
            </Typography>
            <Typography color={"#94A3B8"} fontSize={"12px"} >
              Tray:  {el.slotId ? el.slotId.toString()[0] : "-"}
            </Typography>
            </Box>
            <Typography variant="body2" color="#94A3B8">
             <span color="#94A3B8"><TruncatedDescribation text={el?.description} limit={35} /></span>
             
            </Typography>
              <Typography variant="body2" color="#94A3B8">
               Item Left. {el?.availableCount}
            </Typography>

            {/* Price and Quantity Controls */}
            <Box
              mt={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* Price Section */}
              <Box display="flex" alignItems="center" gap={1}>
                {el.discountedAmount ? (
                  <>
                    <Typography
                      variant="body2"
                      sx={{
                        textDecoration: "line-through",
                        color: "gray",
                        fontSize: "15px",
                      }}
                    >
                      ₹ {el.amount.toFixed(2)}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ fontSize: "14px" }}
                    >
                      ₹ {el.discountedAmount.toFixed(2)}
                    </Typography>
                  </>
                ) : (
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={{ fontSize: "14px" }}
                  >
                    ₹ {el.amount.toFixed(2)}
                  </Typography>
                )}
              </Box>

              {/* Quantity Controls */}
              {el.count > 0 ? (
                <Box
                style={{backgroundColor:"#00B177"}}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width={100}
                  px={1}
                  py={0.5}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  bgcolor="rgba(0, 177, 119, 0.04)"
                 
                >
                  <Typography
                    onClick={(e) => decreaseQuantity(e, index, el.slotId, el.count)}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    -
                  </Typography>
                  <Typography fontSize="14px" fontWeight={500} color={"white"}>
                    {el.count}
                  </Typography>
                  <Typography
                    onClick={(e) => increaseQuantity(e, index, el.slotId, el.count,"add")}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    +
                  </Typography>
                </Box>
              ) : (
                <Box
                  onClick={(e) => increaseQuantity(e, index, el.slot_id, el.count,"add")}
                  width={100}
                  textAlign="center"
                  py={0.7}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  color="#00B177"
                  fontWeight={600}
                  sx={{
                    cursor: "pointer",
                    bgcolor: "rgba(0, 177, 119, 0.04)",
                    userSelect: "none",
                  }}
                >
                  ADD
                </Box>
              )}
            </Box>
          </Box>
        </Box>
  }
        </React.Fragment>
      ))}

      
      <CouponSection fullObjectRewardCart={fullObjectRewardCart} removebtnflag={removebtnflag} fetchCouponsList={fetchCouponsList} setShowCoupoListFlag={setShowCoupoListFlag} ConformRemoveCoupon={ConformRemoveCoupon} RemoveCoupon={RemoveCoupon} />

       

  {/*     <MoreCardsSection/> */}
            <CouponRewardCard fullObjectRewardCart={fullObjectRewardCart} />

             {digitalSuggestionItems?.length > 0 && (
              <QuickPurchaseCards digitalSuggestionItems={digitalSuggestionItems} increaseQuantity={increaseQuantity}  decreaseQuantity={decreaseQuantity}  />
            )}
      </div>
    </>
  );
};

export default CartList;
